import { FETCH_USER_FROM_SF_SUCCESS, FETCH_USER_FROM_SF_ERROR } from '../constants/ActionTypes';

export default function userFetchedFromSF(state = false, action) {
    switch (action.type) {
        case FETCH_USER_FROM_SF_SUCCESS:
        case FETCH_USER_FROM_SF_ERROR:
            return true;
        default:
            return state;
    }
}
